import { initCurrentLocationSearch } from '@common/utils/currentLocationSearch'

initCurrentLocationSearch()
